module.exports = __webpack_public_path__ + "img/server.2b3b9758.svg";